module.exports = __webpack_public_path__ + "img/mobile/Banners-freespins/288_title_freespins@1x.png?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/mobile/Banners-freespins/288_title_freespins@1x.png
// module id = 587
// module chunks = 0